// src/components/PrivacyPolicy.js

import React from 'react';
import './PrivacyPolicy.css'; // Optional: Import CSS for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      
      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to Stupid Sales. This privacy policy explains how we collect, use, and protect your personal information when you use our video chat and scheduling services. We are committed to ensuring the privacy and security of both our widget users (companies) and their visitors.
          If you have any questions about this privacy policy, please contact us at alexren268@gmail.com.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <h3>For Widget Users (Companies)</h3>
        <p>We collect and store the following information:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company name</li>
          <li>Google Calendar authentication tokens (for availability checking)</li>
          <li>Calendar availability data</li>
        </ul>

        <h3>For Visitors</h3>
        <p>We temporarily process, but do not permanently store, the following information:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company name</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <h3>Widget Users (Companies)</h3>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and maintain our video chat service</li>
          <li>Check calendar availability for scheduling</li>
          <li>Send notifications about visitor requests</li>
          <li>Manage your account and verify your identity</li>
          <li>Provide customer support</li>
        </ul>

        <h3>Visitors</h3>
        <p>We use your information to:</p>
        <ul>
          <li>Facilitate video chat connections</li>
          <li>Send confirmation emails about your chat session</li>
          <li>Notify the host (widget user) about your request</li>
        </ul>
      </section>

      <section>
        <h2>Third-Party Services</h2>
        <p>We use the following third-party services to provide our service:</p>
        <ul>
          <li>Supabase - For secure data storage</li>
          <li>Daily.co - For video chat functionality</li>
          <li>Calendly - For scheduling functionality</li>
          <li>Google APIs - For calendar integration</li>
          <li>Twilio - For communication services</li>
        </ul>
        <p>Each of these services has their own privacy policy and terms of service. We encourage you to review their policies.</p>
      </section>

      <section>
        <h2>Data Security</h2>
        <p>
          We implement appropriate technical and organizational security measures to protect your personal information. These include:
        </p>
        <ul>
          <li>Encryption of data in transit and at rest</li>
          <li>Secure storage through Supabase</li>
          <li>Regular security assessments</li>
          <li>Limited access to personal information by our staff</li>
        </ul>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your information</li>
          <li>Withdraw consent for data processing</li>
          <li>Request a copy of your data</li>
        </ul>
        <p>To exercise these rights, please contact us at alexren268@gmail.com</p>
      </section>

      <section>
        <h2>Google API Services User Data Policy</h2>
        <p>
          Our application's use of information received from Google APIs adheres to the Google 
          <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">
             API Services User Data Policy
          </a>, including the Limited Use requirements.
        </p>
        <p>
          We access Google Calendar data solely to:
        </p>
        <ul>
          <li>Check availability for scheduling meetings</li>
          <li>Create and manage calendar events related to video chat sessions</li>
        </ul>
        <p>
          We do not transfer, sell, or use this data for advertising purposes.
        </p>
      </section>

      <section>
        <h2>Changes to This Policy</h2>
        <p>
          We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the effective date.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us:
        </p>
        <ul>
          <li>Email: alexren268@gmail.com</li>
          <li>Company: Stupid Sales</li>
        </ul>
      </section>

      <footer>
        <p>Last updated: {new Date().toLocaleDateString()}</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;